import { Component, EventEmitter, Input, OnChanges, OnInit, Output, AfterViewInit, SimpleChange, ViewChild, ElementRef, HostListener, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DynamicFormArea, DynamicFormOptions, FieldConfig, FieldTypeEnum, FormFieldHighlight, FormFieldsErrors } from './dynamicForm.interface';
import * as _ from 'lodash';
import { catchError, delay, filter, map, switchMap, takeUntil } from 'rxjs/operators';
import { fadeInOutWithBlur, slideDownUp, slideDownUpWithBlur } from '../global-app-animations';
import { GlobalService } from 'src/app/services/global.service';
import { EMPTY, Observable, of, Subject } from 'rxjs';
import { trigger, transition, style, animate } from '@angular/animations';
import { ToastService } from '../toast/toast.service';
import { DynamicformApiService } from './dynamicform-api.service';
import { BaseResponse } from 'src/app/model/response/base-response';
import { environment } from 'src/environments/environment';
import { Session, User } from 'src/app/features/login/login';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { CustomOverlayMessaggeOptions } from '../custom-overlay-messagge/custom-overlay-messagge';
import { NavigationStart, Router } from '@angular/router';
import { CustomOverlayMessaggeComponent } from '../custom-overlay-messagge/custom-overlay-messagge.component';
import { Location } from '@angular/common';
import { DropdownListDataSourceEvent } from '../custom-drop-down-list/customDropDownList.interface';


@Component({
  selector: 'app-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss'],
  animations: [
    slideDownUp,
    fadeInOutWithBlur,
    slideDownUpWithBlur,
    trigger('slideDownUpFast', [
      transition(':enter', [
        style({ overflow: 'hidden', height: '0', opacity: 0, 'padding': "0", 'margin': "0" }),
        animate('450ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ overflow: 'hidden', height: '*', opacity: 1, 'padding': "*", 'margin': "*" })),
      ]),
      transition(':leave', [
        style({ overflow: 'hidden', height: '*', opacity: 1, 'padding': "*", 'margin': "*" }),
        animate('450ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ overflow: 'hidden', height: '0', 'padding-top': 0, 'padding-bottom': 0, opacity: 0, 'padding': "0", 'margin': "0" })),
      ]),
    ]),
  ],
  standalone: false
})
export class DynamicFormComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {

  @Input() options: DynamicFormOptions | undefined;
  @Input() fields: FieldConfig[] = [];
  @Input() formStatus: string = '';
  @Input() dataSource: any;
  @Input() getDataSource: EventEmitter<string> = new EventEmitter<string>();//dropdown
  @Input() updateDataSource: EventEmitter<string> = new EventEmitter<string>();//dropdown

  //@Input() embedTemplate: TemplateRef<any> | undefined;

  // inviano qualcosa quando viene eseguito qualcosa
  @Output() submit: EventEmitter<any> = new EventEmitter<any>();
  @Output() onFormChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onFieldChangeEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() onNoSubmitClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() onButtonMenuClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() onInputChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSelectChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSwitchChange: EventEmitter<any> = new EventEmitter<any>();            // quando cambia lo stato dello switch
  @Output() onCheckboxChange: EventEmitter<any> = new EventEmitter<any>();          // quando cambia lo stato del checkbox
  @Output() onMultiSelChange: EventEmitter<any> = new EventEmitter<any>();          // quando cambia nel multi select
  @Output() onMultiLazyChanges: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSelectLazyChanges: EventEmitter<any> = new EventEmitter<any>();
  @Output() onKeyUp: EventEmitter<any> = new EventEmitter<any>();
  @Output() resetData: EventEmitter<any> = new EventEmitter<any>();

  @Output() onitemSelectChanges: EventEmitter<any> = new EventEmitter<any>();
  @Output() onFormEnabled: EventEmitter<any> = new EventEmitter<any>();


  @Input() triggerMultiUpdate: EventEmitter<any> = new EventEmitter<any>();
  @Output() updateMultiData: EventEmitter<any> = new EventEmitter<any>();
  @Output() sendDataSourceDropdown: EventEmitter<DropdownListDataSourceEvent> = new EventEmitter<DropdownListDataSourceEvent>();//dropdown
  @Output() dropdownDataSourceReady: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild('theForm') theForm!: ElementRef;
  @ViewChild('deleteDialog') deleteDialog: CustomOverlayMessaggeComponent | undefined;
  @ViewChild('exitDialog') exitDialog: CustomOverlayMessaggeComponent | undefined;

  //alert when closing and editing
  // @HostListener('window:beforeunload', ['$event'])
  // beforeunloadHandler(event:any) {
  //   if(this.formStatus!='disable'){
  //     return false;
  //   }

  //   else{
  //     return true;
  //   }
  //   //I have used return false but you can your other functions or any query or condition
  // }

  parsedOptions: DynamicFormOptions = {
    buttonAtBottom: false,
  };

  dialogMessaggeOptions: CustomOverlayMessaggeOptions = {
    dialogTitle: "Stai per eliminare questo elemento, procedere?",
    deleteDialogOptions: {
      deleteEntityName: '',
      deleteUrl: ``,
      isFem: false,
    }
  };

  exitDialogMessaggeOptions: CustomOverlayMessaggeOptions = {
    dialogTitle: "Uscendo perderai le modifiche, procedere?",
  };

  parsedFields: FieldConfig[] = [];
  defaultArea: DynamicFormArea[] = [{ name: '', cssClass: '', width: 'w-full' }]

  form!: FormGroup;

  buttonCount: number = 0;

  sidebarOpen: boolean = true;

  buttonBarOpen: boolean = true;

  isMobile: boolean = false;

  formFieldsErrors: Array<FormFieldsErrors> = [];
  displayError: boolean = false;

  currentSession?: string;

  nextRoute: string = '';
  isSubmit: boolean = false;

  private theEnd$: Subject<void> = new Subject<void>();
  public formFieldsErrors$: Subject<Array<FormFieldsErrors>> = new Subject<Array<FormFieldsErrors>>();

  constructor(private fb: FormBuilder,
    private localStorageService: LocalStorageService,
    public globalService: GlobalService,
    private toastService: ToastService,
    private dynamicFormService: DynamicformApiService,
    private location: Location,
    private router: Router) {
    this.currentSession = this.localStorageService.getGUID();

    this.nextRoute = this.router.url;

    this.router.events.pipe(takeUntil(this.theEnd$), filter(event => event instanceof NavigationStart)).subscribe((event: any) => {
      const targetUrl = event.url;
      const currentRoute = this.router.routerState;
      //console.log('USER WANTS TO GO TO ' + event.url)
      if (this.form.dirty && !this.isSubmit && this.form.enabled) {
        if (event.url != currentRoute) {

          const leave = confirm('Hai modifiche non salvate, proseguire?');
          if (!leave) {
            //console.log('GOING TO ' + this.nextRoute)
            this.router.navigateByUrl(currentRoute.snapshot.url, { skipLocationChange: true });
          }
        }
      }

      this.nextRoute = targetUrl;

    });

  }


  @HostListener('window:beforeunload', ['$event'])
  handleBeforeUnload(event: any) {

    if (this.form.dirty && !this.isSubmit && this.form.enabled) {
      return false;
    } else {

      return true;
    }

  }




  ngOnInit(): void {

    this.isMobile = this.globalService.isMobile();

    this.form = this.createParsedFieldsControl();

    this.form = this.createControl();

    if (this.options != undefined) {
      if (this.options.buttonAtBottom != true) {
        this.options.buttonAtBottom = false;
      }

      if(this.options.formType == 'edit'){
        //this.formStatus = 'disable';
        //this.form.disable();
      }
      
      this.addButtonsToForm(this.options);

      this.parseOptions(this.options);
    }



    this.onChanges();
    if (this.formStatus == 'disable')
      this.form.disable();

    this.globalService.closeSidebar.pipe(takeUntil(this.theEnd$)).subscribe({
      next: () => {
        this.sidebarOpen = !this.sidebarOpen;

        setTimeout(() => {
          if (this.isMobile) {
            if (this.buttonBarOpen == true) {
              if (this.sidebarOpen == false) {
                this.buttonBarOpen = false;
              } else {
                this.buttonBarOpen = true;
              }
            }
          }
        }, 10);
      }
    })

    this.globalService.isMobile$.pipe(takeUntil(this.theEnd$)).subscribe(val => {
      this.isMobile = val;
    });

    this.formFieldsErrors$.pipe(takeUntil(this.theEnd$)).subscribe({
      next: (data: Array<FormFieldsErrors>) => {
        this.formFieldsErrors = data;
        this.displayError = true;
      }
    })

  }


  ngOnDestroy(): void {
    this.dynamicFormService.setDirty(false);
    this.theEnd$.next();
    this.theEnd$.complete();
  }


  ngOnChanges(changes: { options: SimpleChange, fields: SimpleChange, formStatus: SimpleChange, parsedFields: SimpleChange }): void {

    if (changes.options){

      this.parseOptions(changes.options.currentValue);
    }
    if (changes.fields){
      this.parseFields(changes.fields.currentValue);
    }

    if (changes.formStatus) {
      setTimeout(() => {
        if (changes.formStatus.currentValue == 'disable') {
          this.form.disable();
        } else {
          this.form.enable();
        }
      }, 10);

    }

    if (changes.parsedFields)
      this.parseOptions(changes.options.currentValue);
  }

  ngAfterViewInit(): void {

  }


  addButtonsToForm(options: DynamicFormOptions){
    if (options.formType) {
      if (options.formType == 'edit') {
        //this.formStatus = 'disable';
        let buttons: FieldConfig[] = [{
          name: 'modifica',
          type: FieldTypeEnum.button,
          label: 'Salva le modifiche',
          buttonType: 'submit',
          isDisabled: false,
          buttonId: 1,
          //cssClass: 'e-primary'

        },
        // {
        //   name: 'sblocca',
        //   type: FieldTypeEnum.button,
        //   label: 'Sblocca',
        //   buttonType: 'unlock',
        //   isDisabled: false,
        //   buttonId: 2,
        //   //cssClass: 'e-primary e-unlock'
        // },

        // {
        //   name: 'elimina',
        //   type: FieldTypeEnum.button,
        //   label: 'Elimina',
        //   buttonType: 'delete',
        //   isDisabled: false,
        //   buttonId: 3,
        //   //cssClass: 'e-primary e-unlock'
        // },
      ]

        buttons.forEach(b => {
          if (!this.fields.find(f => f.buttonId === b.buttonId)) {
            this.fields.push(b);
          }
        });

      }

      if (options.formType == 'add') {
        let buttons: FieldConfig[] = [{
          name: 'aggiungi',
          type: FieldTypeEnum.button,
          label: 'Aggiungi',
          buttonType: 'submit',
          isDisabled: false,
          buttonId: 1,
          //cssClass: 'e-primary'

        },
        {
          name: 'annulla',
          type: FieldTypeEnum.button,
          label: 'Annulla',
          buttonType: 'cancel',
          isDisabled: false,
          buttonId: 2,
          //cssClass: 'e-primary e-unlock'
        },

        ]

        buttons.forEach(b => {
          if (!this.fields.find(f => f.buttonId === b.buttonId)) {
            this.fields.push(b);
          }
        });

      }


      if(options.formType == 'view'){
        this.fields = _.cloneDeep(this.fields.filter(x=> x.type != FieldTypeEnum.button));
      }
    }
  }

  get value() {
    return this.form!.value;
  }

  onKeyUpInput(event: any) {
    this.onKeyUp.emit(event);
  }

  selectChange(event: any) {
    this.onSelectChange.emit(event);
    this.onFieldChangeEmitter.emit(event);
  }

  onFieldChange(event: any) {
    // event['values'] = this.form!.value;
    this.onFieldChangeEmitter.emit(event);
  }

  noSumitClick(event: any) {
    if (this.options?.formType) {
      switch (event) {
        case 'modifica': this.lockCheck(); break;
        case 'sblocca': this.unlock(); break;
        case 'elimina': this.delete(); break;
        case 'annulla': this.refreshFormData(); break;
        default: this.onNoSubmitClick.emit(event);
      }
    } else {
      this.onNoSubmitClick.emit(event);
    }

  }

  buttonMenuClick(event: any) {
    this.onButtonMenuClick.emit(event);
  }


  onChanges(): void {
    this.form!.valueChanges.pipe(
      delay(50),
    ).subscribe(val => {
      this.onFormChange.emit({ form: this.form, values: val });
      this.dynamicFormService.setDirty(this.form.dirty);
    });
  }


  returnActiveButtons(): number {
    return this.fields.filter(x => x.type == 'button' && x.hidden != true).length;
  }

  // multi select change
  multiChange(event: any): void {
    this.onMultiSelChange.emit(event);
    console.log(event)
  }

  inputChange(event: any) {
    this.onInputChange.emit(event);
  }

  // cambiamenti allo switch
  switchChange(event: any) {
    this.onSwitchChange.emit(event);
  }

  // cambiamenti al checkbox
  checkBoxChange(event: any) {
    this.onCheckboxChange.emit(event);
  }

  multiLazyChanges(event: any) {
    this.onMultiLazyChanges.emit(event);
  }

  itemSelectChanges(event: any) {
    this.onitemSelectChanges.emit(event);
  }

  getFieldInArea(area: number): FieldConfig[] {
    if (area == 1) {

      return this.parsedFields.filter(x => (x.area == 1 || x.area == undefined) && x.hidden != true);
    } else {
      return this.parsedFields.filter(x => x.area == area && x.hidden != true);
    }
  }

  getDataSourceFromDropdown(fieldName:string){
    console.log('FIRED EVENT FOR GETTING '+ fieldName)
    this.getDataSource.emit(fieldName);
  }
  
  updateDataSourceOfDropdown(fieldName:string){
    this.updateDataSource.emit(fieldName);
  }


  sendDataSourceOfDropdown(data: DropdownListDataSourceEvent){
    this.sendDataSourceDropdown.emit(data);
  }

  createControl() {

    const group = this.fb.group({});
    this.fields.forEach(field => {
      if (field.isRequired == true) {
        if (field.label?.includes('*')) {
          field.label = field.label;
        } else
          field.label += '*';
      }
      if (field.type === 'button') {
        this.buttonCount++;
        console.log(this.buttonCount)
      }
      if (field.type === 'button' || field.type === 'title' || field.type === 'divider') return;
      const control = this.fb.control(
        field.value,
        field.type !== 'date' ? this.bindValidations(field.validations || []) : null,
      );
      group.addControl(field.name || '', control);
    });
    this.buttonCount /= 2;
    if (this.buttonCount == 3) {
      let style = document.createElement('style');
      style.innerHTML = '.e-primary { width: 11.5rem; margin:0.5rem} ';
      document.head.appendChild(style);

    }

    return group;
  }

  createParsedFieldsControl() {

    const group = this.fb.group({});
    this.parsedFields.forEach(field => {
      if (field.isRequired == true) {
        if (field.label?.includes('*')) {
          field.label = field.label;
        } else
          field.label += '*';
      }
      if (field.type === 'button') {
        this.buttonCount++;
        console.log(this.buttonCount)
      }
      if (field.type === 'button' || field.type === 'title' || field.type === 'divider') return;
      const control = this.fb.control(
        field.value,
        field.type !== 'date' ? this.bindValidations(field.validations || []) : null,
      );
      group.addControl(field.name || '', control);
    });

    return group;
  }

  bindValidations(validations: any) {
    if (validations.length > 0) {
      const validList: Array<any> = [];
      validations.forEach((valid: any) => {
        if (valid.name.indexOf('Fn') > -1) {
          validList.push(valid.validator());
        }
        else {
          validList.push(valid.validator);
        }
      });

      return Validators.compose(validList);
    }
    return null;
  }

  onSubmit(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.form!.valid) {
      this.submit.emit(this.form!.value);
      this.isSubmit = true;
    } else {
      this.validateAllFormFields(this.form!);
    }
  }

  getFormData(): any {
    return this.form.value;
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      control!.markAsTouched({ onlySelf: true });
    });
  }

  // imposta focus su un campo
  setFocus(name: string) {
    console.log("Setting focus");
    let el = this.theForm.nativeElement[name];
    console.warn(el);
    if (el) {
      console.log(`${name} exists`);
      el.focus();
      //el.blur();
    }
  }

  highlightField(names: FormFieldHighlight[]) {
    Object.keys(this.form.controls).forEach((key: string) => {
      const abstractControl = this.form.controls[key];
      let item = names.find(x => x.name == key)
      if (item) {
        console.log(key + ' is in the list');
        abstractControl.setErrors({ 'highlight': item.message });
        abstractControl.markAsDirty();
        abstractControl.markAsTouched();
      }

    });
  }


  private parseOptions(options: DynamicFormOptions) {
    this.parsedOptions = _.cloneDeep(options);
  }

  private parseFields(fields: FieldConfig[]) {
    console.error('PARSING FIELDS')
    this.parsedFields = _.cloneDeep(fields);
    
    if(this.options) this.addButtonsToForm(this.options);
  }

  expandCollapseButtonBar() {
    this.buttonBarOpen = !this.buttonBarOpen;
  }

  //edit form methods

  enableForm() {
    this.formStatus = 'enable';
    this.form.enable();

    let unlockButton = this.fields.find(x => x.buttonId == 2)
    if (unlockButton) {
      unlockButton.label = 'Annulla';
      unlockButton.name = 'annulla';
      unlockButton.buttonType = 'cancel';
    }
    let editSubmitButton = this.fields.find(x => x.buttonId == 1)
    if (editSubmitButton) {
      editSubmitButton.label = "Salva",
        editSubmitButton.name = 'salva';
      editSubmitButton.buttonType = 'submit';
    }
    this.parseFields(this.fields);
  }

  disableForm() {
    this.formStatus = 'disable';
    this.form.disable();

    let unlockButton = this.fields.find(x => x.buttonId == 2)
    if (unlockButton) {
      unlockButton.label = 'Sblocca';
      unlockButton.name = 'sblocca';
      unlockButton.buttonType = 'unlock';
    }
    let editSubmitButton = this.fields.find(x => x.buttonId == 1)
    if (editSubmitButton) {
      editSubmitButton.label = "Modifica",
        editSubmitButton.name = 'modifica';
      editSubmitButton.buttonType = 'button';
    }
    this.parseFields(this.fields);
  }

  refreshFormData(bypass?: boolean) {

    if (this.form.dirty && !this.isSubmit && this.form.enabled && !bypass) {
      const leave = confirm('Hai modifiche non salvate, proseguire?');
      if (leave) {
        this.refreshFormData(true);
      }
    } else {

      if (this.options?.formType == 'edit') {
        this.disableForm();
        this.resetData.emit();
        this.unlock();
      } else {
        if (this.options && this.options.addOptions) {

          this.router.navigate([this.options.addOptions.redirectUrl])
        } else {
          this.form.reset();
        }
      }
    }

  }

  unlock() {

    this.lockReSet().subscribe(success => {
      if (success) {
        this.toastService.success('e-toast-success');
      } else {
        this.toastService.error('Errore durante lo sblocco, aggiorna la pagina e riprova');
      }

    })


  }

  //CHECK LOCK AND ENABLE FORM
  lockCheck(): void {
    if (!this.currentSession) {
      this.disableForm();
      this.toastService.error('Sessione scaduta , aggiorna la pagina e riprova');
      return;
    }

    if (
      this.options &&
      this.options.editOptions &&
      this.options.editOptions.entityName &&
      this.options.editOptions.entityId
    ) {
      this.dynamicFormService
        .checkLock(this.options.editOptions.entityName, this.options.editOptions.entityId,this.currentSession)
        .pipe(
          takeUntil(this.theEnd$),
          switchMap((resp: BaseResponse) => {
            if (
              resp.errorCode === environment.apiErrorCodes.LockedField &&
              resp.error !== this.currentSession
            ) {
              this.disableForm();
              this.toastService.warning(`${resp.error} sta modificando i dati, riprovare più tardi`);
              return EMPTY; // stop here, don't call setLock
            }

            return this.lockSet(); // proceed to lockSet if not locked by someone else
          }),
          catchError((err) => {
            this.disableForm();
            this.toastService.error( err?.error || 'Errore sconosciuto');
            return EMPTY;
          })
        )
        .subscribe((locked: boolean) => {
          if (locked) {
            this.enableForm();
          } else {
            this.toastService.error('Errore durante il lock, aggiorna la pagina e riprova');
          }
        });
    } else {
      this.disableForm();
      this.toastService.error('Errore durante il controllo dei dati, aggiorna la pagina e riprova');
    }
  }


  //LOCK THE FIELD WHEN EDITING
  lockSet(): Observable<boolean> {
    if (
      this.options &&
      this.options.editOptions &&
      this.options.editOptions.entityName &&
      this.options.editOptions.entityId &&
      this.currentSession
    ) {
      return this.dynamicFormService
        .setLock(this.options.editOptions.entityName, this.options.editOptions.entityId,this.currentSession)
        .pipe(
          takeUntil(this.theEnd$),
          map(() => {

            this.onFormEnabled.emit();

            return true;
          }),
          catchError(() => of(false))
        );
    }

    return of(false);
  }

  lockReSet(): Observable<boolean> {
    if (
      this.options &&
      this.options.editOptions &&
      this.options.editOptions.entityName &&
      this.options.editOptions.entityId &&
      this.currentSession
    ) {
      return this.dynamicFormService
        .reSetLock(this.options.editOptions.entityName, this.options.editOptions.entityId, this.currentSession)
        .pipe(
          takeUntil(this.theEnd$),
          map(() => true),
          catchError(() => of(false))
        );
    }

    return of(false);
  }


  //DELETE
  delete() {
    if (!this.deleteDialog || !this.options || !this.options.editOptions) return;

    this.deleteDialog.options = {
      dialogTitle: this.options.editOptions.deleteMessage,
      deleteDialogOptions: {
        deleteEntityName: this.options.editOptions.entityDisplayName,
        deleteUrl: this.options.editOptions.deleteUrl,
        isFem: this.options.editOptions.isFem,
        redirectUrl: this.options.editOptions.redirectUrl,
      }
    }

    this.deleteDialog.parseOptions();

    this.deleteDialog.deleteItem = this.options?.editOptions?.deleteItem;
    this.deleteDialog.showDialog();
  }


}
